import React from 'react';
import { useDispatch } from 'react-redux';
import ListItem from '@material-ui/core/ListItem';
import { selectEntity } from 'actions/map';

import InventoryInfo from './InventoryInfo';
import { useStyles } from './styles';

/**
 * @typedef {Object} EntityItemProps
 * @property {string} title
 * @property {string} subtitle
 * @property {string} description
 * @property {string} type
 * @property {string} color
 */

/**
 * @param {Object} props
 * @param {EntityItemProps} props.entityProps
 * @param {*} props.info
 * @param {string} props.entity
 */
const MapInventoryItem = ({ info, entity, entityProps }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(selectEntity(info));
  };

  return (
    <ListItem onClick={handleClick} className={classes.itemContainer}>
      <InventoryInfo entity={entity} entityProps={entityProps} markerType={info.type_detail?.id} />
    </ListItem>
  );
};

export default MapInventoryItem;
